import { DeviceType } from 'app.config';
import { CmsConfiguration, AppIdEnum } from 'cms/cms.config';
import { EcommerceBrandSettingsOysho } from 'idt-ecommerce-api/config/brandSettings.oy';
import { RenderConfiguration } from 'render/render.config';

import { ROMAN_DES_URL } from './roman.urls';


const CMSCTAPI_BASE_URL = 'https://axdeseccwpslb-oysho.central.inditex.grp';
const CMSMGAPI_BASE_URL = 'https://des-cmsmgapi-content.oy.apps.axdesecocp1.ecommerce.inditex.grp';
const CMSMGSPA_OAUTH_URL = 'https://des-cmsmgspa-content.oy.apps.axdesecocp1.ecommerce.inditex.grp';
const CMSMGAPI_PROTECTED_BASE_URL = `${CMSMGSPA_OAUTH_URL}/cmsmgspa/api/cmsmgapi`;
const SPA_CONTEXT = 'cmsmgspa/web';
const STATIC_SERVER_BASE_URL = 'https://axpreeccnginx2.central.inditex.grp/16/cmsDes';
const NOTIFIER_BASE_URL = 'https://des-cmsnotify-content.oy.apps.axdesecocp1.ecommerce.inditex.grp/cmsnotify';
const ECOMMERCE_API_BASE_URL = 'https://des-oyshocom.inditex.com/itxrest';
const INTERNAL_API_BASE_URL = 'https://des-apigw-swapi.oy.apps.axdesecocp1.ecommerce.inditex.grp/cmsintapi';

export const environment: CmsConfiguration = {
  apiEcommerceBaseUrl: ECOMMERCE_API_BASE_URL,
  isProduction: false,
  amandaImageVideoManagerEnabled: true,
  experimentalFeatures: {
    enableAnalyticsCMS: true,
    gmapsApiKey: 'AIzaSyBQvWJf-uzwe6AUUlIjMftSnEP1NSp5_3c'
  },
  apiBaseUrl: CMSMGAPI_BASE_URL,
  apiProtectedBaseUrl: CMSMGAPI_PROTECTED_BASE_URL,
  apiMaterializedUrl: `${CMSMGAPI_BASE_URL}/api/materialized`,
  jsonDraftUrl: CMSMGAPI_BASE_URL,
  jsonPublishedUrl: `${STATIC_SERVER_BASE_URL}/contents/`,
  enableGraphQlCompression: true,
  assetsUrl: `${STATIC_SERVER_BASE_URL}/assets/`,
  romanUrl: ROMAN_DES_URL,
  notifierUrl: `${NOTIFIER_BASE_URL}/sse`,
  disableGuard: false,
  disallowInsecure: true,
  appPreviewBaseUrl: 'massimoduttidbg:///1/catalog?cmsPath=',
  textStyles: [
    {
      name: 'Cabecera',
      class: 'header',
      styles: {
        color: 'red',
        'font-size': '24pt',
        'line-height': '26pt',
        'text-transform': 'uppercase',
        'font-family': 'serif'
      }
    },
    {
      name: 'Text link',
      class: 'text-link',
      styles: {
        color: 'rgb(51,51,51)',
        'font-size': '12px'
      }
    },
    {
      name: 'Roboto Medium',
      class: 'roboto-medium',
      styles: {
        'font-family': 'Roboto-Medium'
      }
    },
    {
      name: 'Roboto Medium Italic',
      class: 'roboto-medium-italic',
      styles: {
        'font-family': 'Roboto-MediumItalic'
      }
    },
    {
      name: 'RobotoCondensed Regular',
      class: 'roboto-condensed-regular',
      styles: {
        'font-family': 'RobotoCondensed-Regular'
      }
    },
    {
      name: 'RobotoCondensed Bold',
      class: 'roboto-condensed-bold',
      styles: {
        'font-family': 'RobotoCondensed-Bold'
      }
    },
    {
      name: 'RobotoCondensed Bold Italic',
      class: 'roboto-condensed-bold-italic',
      styles: {
        'font-family': 'RobotoCondensed-BoldItalic'
      }
    },
    {
      name: 'RobotoCondensed Italic',
      class: 'roboto-condensed-italic',
      styles: {
        'font-family': 'RobotoCondensed-Italic'
      }
    },
    {
      name: 'RobotoCondensed Light',
      class: 'roboto-condensed-light',
      styles: {
        'font-family': 'RobotoCondensed-Light'
      }
    },
    {
      name: 'RobotoCondensed LightItalic',
      class: 'roboto-condensed-light-italic',
      styles: {
        'font-family': 'RobotoCondensed-LightItalic'
      }
    }
  ],
  // The list of color inline styles
  colorStyles: [
    'rgb(97,189,109)', // green300
    'rgb(26,188,156)', // green500
    'rgb(84,172,210)', // blue300
    'rgb(44,130,201)', // green600
    'rgb(147,101,184)', // purple400
    'rgb(71,85,119)', // blue800
    'rgb(209,213,216)', // gray300 --
    'rgb(65,168,95)', // green400
    'rgb(0,168,133)', // green600
    'rgb(61,142,185)', // blue600
    'rgb(41,105,176)', // green800
    'rgb(85,57,130)', // purple600
    'rgb(40,50,78)', // blue900
    'rgb(204,204,204)', // gray400 ---
    'rgb(247,218,100)', // yellow100
    'rgb(251,160,38)', // orange300
    'rgb(235,107,86)', // orange700
    'rgb(226,80,65)', // orange900
    'rgb(163,143,132)', // brown400
    'rgb(0,0,0)', // black
    'rgb(239,239,239)', // gray100 ---
    'rgb(250,197,28)', // orange100
    'rgb(243,121,52)', // orange500
    'rgb(209,72,65)', // red400
    'rgb(184,49,47)', // red800
    'rgb(124,112,107)', // brown800
    'rgb(51,51,51)', // gray900
    'rgb(255,255,255)' // white
  ],
  ecommerce: {
    apiBaseUrl: `${CMSMGAPI_BASE_URL}/proxy/itxrest/2`,
    brandSettings: EcommerceBrandSettingsOysho,
    brandCode: 'oy',
    appId: AppIdEnum.web,
    catalogType: '1',
    instanceType: 'cms',
    providers: {
      cmsConfigurationsBaseUrl: `${INTERNAL_API_BASE_URL}/api/v1/configurations`,
      cmsTranslationsBaseUrl: `${INTERNAL_API_BASE_URL}/api/v1/translations`,
      cmsCollectionsBaseUrl: `${CMSMGAPI_BASE_URL}/api/collections`,
      colbensonSearchUrl: 'https://api-staging.empathybroker.com/search/v1/query/oysho/searchv3'
    }
  },
  breakpoints: [
    {
      bp: '(min-width: 1280px)',
      name: 'Desktop Wide (>= 1280px)',
      device: [DeviceType.DESKTOP_WIDE],
      previewDimensions: {
        width: 1920,
        height: 1200
      }
    },
    {
      bp: '(min-width: 990px) and (max-width: 1279px)',
      name: 'Desktop (990px - 1279px)',
      device: [DeviceType.DESKTOP],
      previewDimensions: {
        width: 1200,
        height: 1024
      }
    },
    {
      bp: '(min-width: 768px) and (max-width: 989px)',
      name: 'Tablet (768px - 989px)',
      device: [DeviceType.TABLET],
      previewDimensions: {
        width: 820,
        height: 1180
      }
    },
    {
      bp: '(max-width: 767px)',
      name: 'Mobile (< 768px)',
      device: [DeviceType.MOBILE],
      previewDimensions: {
        width: 414,
        height: 896
      }
    }
  ],
  fonts: {
    sources: [
      {
        name: 'RobotoCondensed-Regular',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Bold',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-BoldItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Italic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Light',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-LightItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoBold',
        path: '/font/Roboto/RobotoBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoBoldItalic',
        path: '/font/Roboto/RobotoBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoMedium',
        path: '/font/Roboto/RobotoMedium/',
        fontStyle: 'normal',
        fontWeight: '500'
      },
      {
        name: 'RobotoMediumItalic',
        path: '/font/Roboto/RobotoMediumItalic/',
        fontStyle: 'italic',
        fontWeight: '500'
      },
      {
        name: 'RobotoRegular',
        path: '/font/Roboto/RobotoRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoItalic',
        path: '/font/Roboto/RobotoItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoLight',
        path: '/font/Roboto/RobotoLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoLightItalic',
        path: '/font/Roboto/RobotoLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedBold',
        path: '/font/RobotoCondensed/RobotoCondensedBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedBoldItalic',
        path: '/font/RobotoCondensed/RobotoCondensedBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedRegular',
        path: '/font/RobotoCondensed/RobotoCondensedRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedItalic',
        path: '/font/RobotoCondensed/RobotoCondensedItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedLight',
        path: '/font/RobotoCondensed/RobotoCondensedLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedLightItalic',
        path: '/font/RobotoCondensed/RobotoCondensedLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'oysho-icon-font',
        path: '/font/oysho-icon-font/oysho-icon-font/',
        fontStyle: 'normal',
        fontWeight: '400'
      }
    ],
    domains: {
      default: STATIC_SERVER_BASE_URL
    }
  },
  pageTypes: [
    {
      name: 'home',
      label: 'Home'
    },
    {
      name: 'grid',
      label: 'Parrilla'
    },
    {
      name: 'product',
      label: 'Producto'
    }
  ],
  imPolicyList: [
    'oysho-itxhigh',
    'oysho-itxmediumhigh',
    'oysho-itxmedium',
    'oysho-itxmediumlow',
    'oysho-itxlow'
  ],
  analyticsActionsTypes: [
    {
      name: 'image',
      label: 'Imagen'
    },
    {
      name: 'video',
      label: 'Vídeo'
    },
    {
      name: 'text',
      label: 'Texto'
    },
    {
      name: 'product-carousel',
      label: 'Carrusel de productos'
    },
    {
      name: 'carousel',
      label: 'Carrusel de categorías'
    },
    {
      name: 'button',
      label: 'Botón'
    },
    {
      name: 'custom',
      label: 'Personalizado'
    }
  ],
  appInsightsConnectionString: 'InstrumentationKey=bd3b0657-8895-4fa2-817b-315ccfc40ec4;IngestionEndpoint=https://westeurope-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
  oauthConfig: {
    endpoint: CMSMGSPA_OAUTH_URL,
    appContext: 'cmsmgspa',
    forbiddenUrl: `/${SPA_CONTEXT}/oauth/forbidden`,
    loginErrorUrl: `/${SPA_CONTEXT}/oauth/authentication-error`,
    spaContext: SPA_CONTEXT
  }
};

export const renderEnvironment: RenderConfiguration = {
  apiEcommerceBaseUrl: ECOMMERCE_API_BASE_URL,
  isProduction: false,
  amandaImageVideoManagerEnabled: true,
  experimentalFeatures: {
    enableAnalyticsCMS: true,
    gmapsApiKey: 'AIzaSyBQvWJf-uzwe6AUUlIjMftSnEP1NSp5_3c'
  },
  apiMaterializedUrl: `${CMSCTAPI_BASE_URL}/integration/cms/api/materialized`,
  assetsUrl: `${STATIC_SERVER_BASE_URL}/assets/`,
  ecommerce: {
    apiBaseUrl: `${CMSCTAPI_BASE_URL}/itxrest/2`,
    brandSettings: EcommerceBrandSettingsOysho,
    appId: AppIdEnum.web,
    catalogType: '1',
    instanceType: 'render',
    providers: {
      cmsConfigurationsBaseUrl: `${CMSCTAPI_BASE_URL}/integration/cms/api/config`,
      cmsTranslationsBaseUrl: `${CMSCTAPI_BASE_URL}/integration/cms/api/translations`,
      cmsCollectionsBaseUrl: `${CMSCTAPI_BASE_URL}/integration/cms/api/collections`
    }
  },
  breakpoints: [
    {
      bp: '(min-width: 1280px)',
      name: 'Desktop Wide (>= 1280px)',
      device: [DeviceType.DESKTOP_WIDE]
    },
    {
      bp: '(min-width: 990px) and (max-width: 1279px)',
      name: 'Desktop (990px - 1279px)',
      device: [DeviceType.DESKTOP]
    },
    {
      bp: '(min-width: 768px) and (max-width: 989px)',
      name: 'Tablet (768px - 989px)',
      device: [DeviceType.TABLET]
    },
    {
      bp: '(max-width: 767px)',
      name: 'Mobile (< 768px)',
      device: [DeviceType.MOBILE]
    }
  ],
  fonts: {
    sources: [
      {
        name: 'RobotoCondensed-Regular',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Bold',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-BoldItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Italic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Light',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-LightItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoBold',
        path: '/font/Roboto/RobotoBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoBoldItalic',
        path: '/font/Roboto/RobotoBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoMedium',
        path: '/font/Roboto/RobotoMedium/',
        fontStyle: 'normal',
        fontWeight: '500'
      },
      {
        name: 'RobotoMediumItalic',
        path: '/font/Roboto/RobotoMediumItalic/',
        fontStyle: 'italic',
        fontWeight: '500'
      },
      {
        name: 'RobotoRegular',
        path: '/font/Roboto/RobotoRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoItalic',
        path: '/font/Roboto/RobotoItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoLight',
        path: '/font/Roboto/RobotoLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoLightItalic',
        path: '/font/Roboto/RobotoLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedBold',
        path: '/font/RobotoCondensed/RobotoCondensedBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedBoldItalic',
        path: '/font/RobotoCondensed/RobotoCondensedBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedRegular',
        path: '/font/RobotoCondensed/RobotoCondensedRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedItalic',
        path: '/font/RobotoCondensed/RobotoCondensedItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedLight',
        path: '/font/RobotoCondensed/RobotoCondensedLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedLightItalic',
        path: '/font/RobotoCondensed/RobotoCondensedLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'oysho-icon-font',
        path: '/font/oysho-icon-font/oysho-icon-font/',
        fontStyle: 'normal',
        fontWeight: '400'
      }
    ],
    domains: {
      default: STATIC_SERVER_BASE_URL
    }
  },
  pageTypes: [
    {
      name: 'home',
      label: 'Home'
    },
    {
      name: 'grid',
      label: 'Parrilla'
    },
    {
      name: 'product',
      label: 'Producto'
    }
  ]
};
